import { render, staticRenderFns } from "./App.vue?vue&type=template&id=19d877fe&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "../../shared/sass/lt-main.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "../../shared/sass/saved-cards/app.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./App.vue?vue&type=style&index=2&id=19d877fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d877fe",
  null
  
)

export default component.exports